$(document).on("submit", "form.kf-checkout__form", function (e) {
    let $btn = $(this).find('button[type=submit]');
    let text = $btn.html();
    //disable the submit button
    Common.buttonLoading($btn, text)

    return true;
});
